module.exports = __webpack_public_path__ + "img/img22.4af52c9b.png";